import { BankRatingDetail } from "Components/Shared/BanksList/BankButton/Components/BankRatingDetail/BankRatingDetail";
import type { Bank } from "Infrastructure/Api/Api";
import { Box, Modal, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import { BOTTOM_MENU_HEIGHT } from "Components/Layout/Menu/BottomMenu";
import { Resources, useResource } from "Translations/Resources";

const VERTICAL_MARGIN = "100px";

type BankRatingDetailModalProps = {
  isDialogOpen: boolean;
  handleCloseRating: () => void;
  bank: Bank;
};

export const BankRatingDetailModal = ({
  isDialogOpen,
  handleCloseRating,
  bank,
}: BankRatingDetailModalProps) => {
  const { t } = useResource();

  const maxHeight = `calc(100dvh - ${VERTICAL_MARGIN} - ${BOTTOM_MENU_HEIGHT})`;

  return (
    <Modal open={isDialogOpen} onClose={handleCloseRating} disableRestoreFocus>
      <Box
        role="dialog"
        aria-modal="true"
        sx={({ palette, shadows }) => ({
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          border: `1px solid ${palette.grey[200]}`,
          boxShadow: shadows[3],
          borderRadius: "10px",
          width: { xs: "92vw", sm: "min(92vw, 600px)" },
          maxWidth: 600,
          maxHeight,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          backgroundColor: palette.background.paper,
        })}
      >
        <Box
          position="relative"
          sx={{ maxHeight: "inherit", overflowY: "auto", p: 5 }}
        >
          <IconButton
            aria-label={t(Resources.Common.Back)}
            onClick={handleCloseRating}
            size="small"
            sx={{ position: "absolute", top: 8, right: 8, zIndex: 1 }}
          >
            <Close fontSize="small" />
          </IconButton>
          <BankRatingDetail bank={bank} isInModal />
        </Box>
      </Box>
    </Modal>
  );
};
